import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import {MAT_BOTTOM_SHEET_DATA} from '@angular/material/bottom-sheet';
@Component({
  selector: 'app-rear-camera-bottom-sheet',
  templateUrl: './rear-camera-bottom-sheet.component.html',
  styleUrls: ['./rear-camera-bottom-sheet.component.scss']
})
export class RearCameraBottomSheetComponent implements OnInit {

  constructor(private bottomSheetRef: MatBottomSheetRef<RearCameraBottomSheetComponent>) { }

  ngOnInit() {
  }
  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
